<div class="patientcontainer">
    <div *ngIf="patient.patientid != -1" class="patientinfo" [innerHTML]="patient.info"></div>
    <div *ngIf="patient.patientid == -1" class="patienterror">Veuillez sélectionnez un patient</div> 
    <div *ngIf="patient.patientid != -1">
        <div class="patientmoreicon" dropdown>
            <button type="button" class="btn" id="userdropdown" dropdownToggle><fa-icon [icon]="['fas','bars']" size="lg"></fa-icon></button>
            <ul class="dropdown-menu patient-dropdown-menu" *dropdownMenu>
                <li *ngFor="let menu of patient.patientMenus" role="menuitem"><a (click)="menuClick(menu);" href="#"><fa-icon [icon]="menu.icon" [styles]="menu.icon_style" size="lg"></fa-icon>{{menu.label}}</a></li>
            </ul>
        </div>
        <div class="patientinfoicon"><button (click)="openPatient()" class="btn"><fa-icon [icon]="['fas','address-card']" size="lg"></fa-icon></button></div>
        <div *ngIf="showconsultationbutton" class="patientconsultationicon"><button (click)="openWaitingConsultation()" class="btn"><fa-icon [icon]="['fas','user-friends']"></fa-icon></button></div>
    </div>
    <div *ngIf="patient.patientid != -1">
        <div *ngFor="let icon of patient.patientIcons" class="patientinfoicon">
            <button (click)="iconClick(icon)" class="btn">
                <fa-icon [icon]="icon.icon" [styles]="icon.icon_style" size="lg"></fa-icon>
            </button>
        </div>        
    </div>
</div>